<template>
  <el-dialog title='修改' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='600px'>
    <el-form :model='form' label-width='100px' label-position='right' :rules='rules'
             ref='ruleForm' class='settlement-form mt20'>
      <el-form-item label='船位：' prop='shipPosition'>
        <el-input v-model='form.shipPosition' size='mini' />
      </el-form-item>
      <el-form-item label='里程：' prop='mileage'>
        <el-input v-model='form.mileage' type='number' size='mini' />
      </el-form-item>
      <div class='flex-center-center mt10 mb20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'> 确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { updateShipTracking } from '@/service/financial';

  export default {
    name: 'shipTrackingForm',
    data() {
      return {
        dialogVisible: false,
        defaultForm: {},
        form: {
          id: '',
          shipPosition: '',
          mileage: '',
        },
        rules: {
          shipPosition: [
            {
              required: true,
              message: '请输入船位',
              trigger: 'blur',
            },
          ],
          mileage: [
            {
              required: true,
              message: '请输入里程',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(id) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form.id = id;
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            const {
              status,
              message,
            } = await updateShipTracking(this.form);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 80%;
    margin: 0 auto;
  }
</style>
